//only alphabets with spaces included
export const RegexOnlyAlphabets = /^[a-zA-Z\s]+$/

export const RegexPhoneNumber = /^[0-9#+*-.]+$/

//must contain atleast one alphabet, one number, one special character
export const RegexAlphaNumeric =
  /^((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[A-Za-z]){1}).*$/
